import ENV from '../env'

const NO_IMAGE = require('@/assets/images/misc/no-image.png')

export default { ...ENV, NO_IMAGE }
